<h2 class="text-center" vng-dialog-title>
    Hey, Fix the following errors and Try Again!
</h2>

<ol>
    <li role="listitem" *ngFor="let error of errors; let i = index">{{ error }}</li>
</ol>

<div class="component-row" style="display:flex">
    <button style="flex:1 1 0%" [vngDialogClose]="'closed'" class="btn-mat cancel-btn no-margin" type="button" vng-button variant="secondary" tabindex="2">Cancel</button>
    <button style="flex:1 1 0%" (click)="close()" class="btn-mat no-margin" type="button" vng-button variant="primary" tabindex="-1">Okay</button>
</div>